import { login, logout, getInfo } from "@/api";
import { getToken, setToken, removeToken } from "@/utils/auth";
import router, { resetRouter, asyncRoutes, constantRoutes } from "@/router";

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    // return roles.some((role) => route.meta.roles.includes(role));
    return route.meta.roles.includes(roles);
  } else {
    return true;
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = [];

  routes.forEach((route) => {
    const tmp = { ...route };
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles);
      }
      res.push(tmp);
    }
  });

  return res;
}

const state = {
  routes: [],
  addRoutes: [],
  token: getToken(),
  roles: "",
  email: "",
  expiryDate: null,
  home: null,
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_EXPIRYDATE: (state, date) => {
    state.expiryDate = date;
  },
  SET_EMAIL: (state, email) => {
    state.email = email;
  },
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes;
    state.routes = constantRoutes.concat(routes);
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_HOME: (state, homeRoute) => {
    state.home = homeRoute;
  },
};

const actions = {
  login({ commit, dispatch }, userInfo) {
    const { username, password } = userInfo;
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password })
        .then((response) => {
          const { data } = response;
          commit("SET_TOKEN", data.token);
          setToken(data.token);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token)
        .then((response) => {
          const { data } = response;

          if (!data) {
            reject("认证失败，请重新登录");
          }
          const { roles, email, expiryDate } = data;
          commit("SET_ROLES", roles);
          commit("SET_EMAIL", email);
          commit("SET_EXPIRYDATE", expiryDate);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  generateRoutes({ commit }, roles) {
    return new Promise((resolve) => {
      let accessedRoutes;
      if (roles === "ADMIN") {
        accessedRoutes = asyncRoutes || [];
      } else {
        accessedRoutes = filterAsyncRoutes(asyncRoutes, roles);
      }
      commit("SET_ROUTES", accessedRoutes);
      commit("SET_HOME", accessedRoutes[0]);
      accessedRoutes.forEach((route) => {
        router.addRoute("layout", route);
      });
      router.addRoute({ path: "*", redirect: "/404", hidden: true });
      resolve(accessedRoutes);
    });
  },
  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout()
        .then(() => {
          commit("SET_TOKEN", "");
          commit("SET_ROLES", "");
          removeToken();
          resetRouter();
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  resetToken({ commit }) {
    return new Promise((resolve) => {
      commit("SET_TOKEN", "");
      commit("SET_ROLES", "");
      removeToken();
      resolve();
    });
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
